<template>
  <b-form-group :label="value.label">
    <date-picker
      v-model="value.value"
      :config="{ format: 'DD-MM-YYYY' }"
    />
  </b-form-group>
</template>

<script>
  import DatePicker from "vue-bootstrap-datetimepicker";
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

  export default {
    props: ['value'],

    components: {DatePicker},
  }
</script>
